<template>
  <div class="container view-page">
    <component
      :is="navigateComponent"
      v-if="appMenus"
      :userName="userName"
    ></component>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import navigateTopLeft from './navigate-top-left'
import navigateLeft from './navigate-left'
import navigateLeftChange from './navigate-left-change'
import navigateTop from './navigate-top'
export default {
  name: 'view-page',
  props: {
    userName: String
  },
  computed: {
    ...mapGetters([
      'navigateSchema',
      'appMenus'
    ]),
    navigateComponent () {
      return this.componentMap[this.navigateSchema]
    }
  },
  created () {
    this.componentMap = {
      'nav-type1': 'navigateLeftChange',
      'nav-type2': 'navigateTopLeft',
      // 'nav-type3': 'navigateLeft',
      'nav-type3': 'navigateTop',
      'nav-type4': 'navigateTop'
    }
  },
  components: {
    navigateTopLeft,
    navigateLeft,
    navigateLeftChange,
    navigateTop
  }
}
</script>

<style lang="scss" scoped>
.view-page.container {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
</style>
